import React from 'react'
import PropTypes from 'prop-types'
import { DataGrid } from '@mui/x-data-grid'
import { Box, Typography, Link } from '@mui/material'

const fmt = (n) => n != null ? `$ ${Number(n).toLocaleString('en-US', { minimumFractionDigits: 2 })}` : '—'

const columns = [
  { field: 'lineNumber', headerName: '#', width: 50, headerAlign: 'center', align: 'center' },
  { field: 'sku', headerName: 'NDC/Items #', flex: 0.7, minWidth: 130 },
  { field: 'description', headerName: 'Item Description', flex: 1, minWidth: 180 },
  { field: 'uom', headerName: 'UOM', width: 60, headerAlign: 'center', align: 'center' },
  { field: 'totalQty', headerName: 'Total Qty', width: 80, headerAlign: 'right', align: 'right' },
  { field: 'openQty', headerName: 'Open Qty', width: 80, headerAlign: 'right', align: 'right' },
  {
    field: 'shippedQty', headerName: 'Shipped Qty', width: 90, headerAlign: 'right', align: 'right',
    renderCell: (p) => <>{p.value || '-'}</>,
  },
  {
    field: 'allocatedQty', headerName: 'Allocated Qty', width: 100, headerAlign: 'right', align: 'right',
    renderCell: (p) => <>{p.value || '-'}</>,
  },
  {
    field: 'unitPrice', headerName: 'Unit Price', width: 90, headerAlign: 'right', align: 'right',
    renderCell: (p) => <>{fmt(p.value)}</>,
  },
  { field: 'priceType', headerName: 'Price Type', width: 90 },
  {
    field: 'lineTotal', headerName: 'Line Total', width: 100, headerAlign: 'right', align: 'right',
    renderCell: (p) => (
      <Typography sx={{ fontSize: '0.85rem', fontFamily: 'AtlasGroteskRegular', fontWeight: 600 }}>
        {fmt(p.value)}
      </Typography>
    ),
  },
]

function OrderLineDetailsTableV2({ lines }) {
  const rows = (lines || []).map((l) => ({
    id: l.lineNumber,
    lineNumber: l.lineNumber,
    sku: l.sku,
    description: l.description,
    uom: l.uom,
    totalQty: l.totalQty,
    openQty: l.openQty,
    shippedQty: l.shippedQty,
    allocatedQty: l.allocatedQty,
    unitPrice: l.unitPrice,
    priceType: l.priceType,
    lineTotal: l.totalQty * l.unitPrice,
  }))

  return (
    <Box>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1.5 }}>
        <Typography sx={{ fontFamily: 'SanomatMedium', fontSize: '1.3rem', color: '#1a8a6a' }}>
          Order Line Details
        </Typography>
        <Link href='#' underline='hover' sx={{ fontSize: '0.82rem', fontFamily: 'AtlasGroteskRegular', color: '#1a8a6a' }}>
          See Inventory Details
        </Link>
      </Box>
      <Box sx={{ backgroundColor: '#fff', border: '1px solid #e7e7e7', borderRadius: 2 }}>
        <DataGrid
          rows={rows}
          columns={columns}
          pageSizeOptions={[25]}
          initialState={{ pagination: { paginationModel: { pageSize: 25, page: 0 } } }}
          disableColumnFilter
          disableRowSelectionOnClick
          autoHeight
          hideFooter={rows.length <= 25}
          sx={{
            border: 'none',
            '& .MuiDataGrid-columnHeaders': { backgroundColor: '#f8f8f8' },
            '& .MuiDataGrid-columnHeaderTitle': { fontFamily: 'AtlasGroteskRegular', fontSize: '0.78rem', fontWeight: 700, color: '#555' },
            '& .MuiDataGrid-cell': { fontFamily: 'AtlasGroteskRegular', fontSize: '0.82rem' },
          }}
        />
      </Box>
    </Box>
  )
}

OrderLineDetailsTableV2.propTypes = { lines: PropTypes.array }

export default OrderLineDetailsTableV2
